import { multiLangTextObject } from "./../../utils/multiLang.js";

/*
 * defaults are the default values applied to the tags
 * when they are dragged or added from the list
 */
const defaults = [
  {
    key: "buttonTag",
    label: "Button",
    waypoints: 2,
    bounds: {
      w: 240,
      h: 80
    },
    icon: "check_box_outline_blank",
    docs: "interactive-elements/button.html"
  },
  {
    key: "textbox",
    label: "Text Box",
    waypoints: 2,
    bounds: {
      w: 300,
      h: 100
    },
    icon: "text_fields",
    docs: "interactive-elements/text-box.html"
  },
  {
    key: "hotspot",
    label: "Hotspot",
    waypoints: 2,
    bounds: {
      w: 200,
      h: 100
    },
    icon: "fingerprint",
    docs: "interactive-elements/hotspot.html"
  },
  {
    key: "ptag",
    label: "Bubble",
    waypoints: 2,
    bounds: {
      wh: 40
    },
    icon: "label",
    docs: "interactive-elements/bubble.html"
  },
  {
    key: "generic",
    label: "Annotation",
    waypoints: 2,
    bounds: {
      w: 80,
      h: 80
    },
    icon: "location_on",
    docs: "interactive-elements/annotation.html"
  },
  {
    key: "hotdot",
    label: "Icon Button",
    waypoints: 2,
    bounds: {
      w: 50,
      h: 50
    },
    icon: "radio_button_checked",
    docs: "interactive-elements/icon-button.html"
  },
  {
    key: "imageTag",
    label: "Image",
    waypoints: 2,
    bounds: {
      w: 200,
      h: 100
    },
    icon: "image",
    docs: "interactive-elements/image.html"
  },
  {
    key: "quiz",
    label: "Quiz",
    waypoints: 1,
    x: 0.5,
    y: 0.5,
    icon: "help",
    docs: "interactive-elements/quiz.html"
  },
  {
    key: "quizzes",
    label: "Multi quizzes",
    waypoints: 1,
    x: 0.5,
    y: 0.5,
    icon: "help",
    docs: "interactive-elements/multi-quizzes.html"
  },
  // {
  //   key: "singleChoice",
  //   label: "Action List",
  //   waypoints: 1,
  //   x: 0.5,
  //   y: 0.5,
  //   icon: "list"
  // },
  {
    key: "logic",
    label: "Logic",
    waypoints: 1,
    x: 0.5,
    y: 0.5,
    icon: "settings",
    docs: "interactive-elements/logic.html"
  },
  {
    key: "filter",
    label: "Video Filter",
    waypoints: 2,
    x: 0.5,
    y: 0.5,
    icon: "opacity",
    docs: "interactive-elements/video-filter.html"
  },
  {
    key: "markerTag",
    label: "Marker",
    x: 0.5,
    y: 0.5,
    waypoints: 1,
    docs: "interactive-elements/marker.html"
  }
  // {
  //   key: "cover",
  //   label: "iFrame",
  //   waypoints: 2,
  //   icon: "texture"
  // },
  // {
  //   key: "customEmbed",
  //   label: "Custom Component",
  //   waypoints: 2,
  //   icon: "widgets"
  // }
];

/**
 * defs are the definitions (fields and types) to build the generic form
 * forthe tags. Defines all the properties of a tag.
 */
const defs = {
  generic: [
    {
      value: "",
      key: "initalShow",
      label: "initially visible",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    },
    {
      value: multiLangTextObject(),
      key: "title",
      label: "Titel",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/title.html"
    },
    {
      value: multiLangTextObject(),
      key: "text",
      label: "Description",
      tag: "textarea",
      type: "textarea",
      multilang: true,
      docPath: "properties/description.html"
    },
    {
      value: multiLangTextObject(),
      key: "linkLabel",
      label: "Link Label",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/link-label.html"
    },
    {
      value: {},
      key: "behaviour",
      label: "On click",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/on-click.html"
    },
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/action-on-last-waypoint.html"
    },
    {
      value: "",
      key: "colorScheme",
      label: "Color Style",
      tag: "color-scheme-select",
      type: "color-scheme-select",
      docPath: "properties/color-style.html",
      options: [
        {
          id: "annotation-1",
          label: "annotation 1"
        },
        {
          id: "annotation-2",
          label: "annotation 2"
        },
        {
          id: "annotation-3",
          label: "annotation 3"
        },
        {
          id: "annotation-custom-color",
          label: "custom"
        },
        {
          id: "annotation-custom-color-2",
          label: "custom 2"
        }
      ]
    },
    {
      value: "",
      key: "textAlignement",
      label: "Text alignement",
      tag: "align-picker",
      type: "align-picker",
      options: ["t-left", "t-center", "t-right", "t-justify"],
      docPath: "properties/text-alignement.html"
    },
    {
      value: "",
      key: "icon",
      label: "Icon",
      tag: "icon-picker",
      type: "icon-picker",
      docPath: "properties/icon.html"
    }
  ],
  ptag: [
    {
      value: multiLangTextObject(),
      key: "title",
      label: "Title",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/title.html"
    },
    {
      value: multiLangTextObject(),
      key: "text",
      label: "Description",
      tag: "textarea",
      type: "textarea",
      multilang: true,
      docPath: "properties/description.html"
    },
    {
      value: multiLangTextObject(),
      key: "eyecatcher",
      label: "Eyecatcher",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/eyecatcher.html"
    },
    {
      value: multiLangTextObject(),
      key: "linkLabel",
      label: "Link Label",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/link-label.html"
    },
    {
      value: {},
      key: "behaviour",
      label: "On click",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/on-click.html"
    },
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/"
    },
    {
      value: "",
      key: "colorScheme",
      label: "Color Style",
      tag: "color-scheme-select",
      type: "color-scheme-select",
      docPath: "properties/color-style.html",
      options: [
        {
          id: "shop-box",
          label: "shop arrow box"
        },
        {
          id: "shop-box-2",
          label: "shop arrow box 2"
        },
        {
          id: "shop-box-3",
          label: "shop arrow box 3"
        },
        {
          id: "shop-transparent-light",
          label: "shop transparent light"
        },
        {
          id: "shop-transparent-dark",
          label: "shop transparent black"
        },
        {
          id: "shop-custom-color",
          label: "custom"
        },
        {
          id: "shop-custom-color-2",
          label: "custom 2"
        }
      ]
    },
    {
      value: "h-left",
      key: "alignement",
      label: "Box alignement",
      tag: "align-picker",
      type: "align-picker",
      options: ["h-left", "h-center", "h-right"],
      docPath: "properties/box-alignement.html"
    },
    {
      value: "t-center",
      key: "textAlignement",
      label: "Text alignement",
      tag: "align-picker",
      type: "align-picker",
      options: ["t-left", "t-center", "t-right", "t-justify"],
      docPath: "properties/text-alignement.html"
    },
    {
      value: true,
      key: "initalShow",
      label: "initially visible and not on toggle",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    }
  ],
  annotation: [
    {
      value: "",
      key: "initalShow",
      label: "initially visible",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    },
    {
      value: multiLangTextObject(),
      key: "title",
      label: "Name",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/title.html"
    },
    {
      value: multiLangTextObject(),
      key: "text",
      label: "Description",
      tag: "textarea",
      type: "textarea",
      multilang: true,
      docPath: "properties/description.html"
    },
    {
      value: "",
      key: "icon",
      label: "Icon",
      tag: "icon-picker",
      type: "icon-picker",
      docPath: "properties/icon.html"
    }
  ],
  tip: [
    {
      value: "",
      key: "initalShow",
      label: "initially visible",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    },
    {
      value: multiLangTextObject(),
      key: "title",
      label: "Name",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/title.html"
    },
    {
      value: "",
      key: "icon",
      label: "Icon",
      tag: "icon-picker",
      type: "icon-picker",
      docPath: "properties/icon.html"
    }
  ],
  markerTag: [
    {
      value: "",
      key: "icon",
      label: "Icon",
      tag: "icon-picker",
      type: "icon-picker",
      docPath: "properties/icon.html"
    }
  ],
  imageTag: [
    {
      value: multiLangTextObject(),
      key: "imageSrc",
      label: "Image",
      tag: "image-cropper",
      type: "image-cropper",
      multilang: true,
      docPath: "properties/fill.html"
    },
    {
      value: 0,
      key: "borderRadius",
      label: "Border radius",
      tag: "cling-slider",
      type: "cling-slider",
      options: {
        min: 0,
        max: 50
      },
      docPath: "properties/border-radius.html"
    },
    {
      value: 0,
      key: "boxShadow",
      label: "Shadow",
      tag: "cling-slider",
      type: "cling-slider",
      options: {
        min: 0,
        max: 25
      },
      docPath: "properties/border-radius.html"
    },
    {
      value: {},
      key: "behaviour",
      label: "On click",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/on-click.html"
    },
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/"
    },
    {
      value: {},
      key: "animation",
      label: "Animation",
      tag: "choose-animation",
      type: "choose-animation",
      docPath: "properties/animation.html"
    },
    {
      value: true,
      key: "initalShow",
      label: "initially visible and not on toggle",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    }
  ],
  buttonTag: [
    {
      value: multiLangTextObject(),
      key: "text",
      label: "Button Label",
      tag: "textarea",
      type: "textarea",
      multilang: true,
      docPath: "properties/button-label.html"
    },
    {
      value: {},
      key: "behaviour",
      label: "On click",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/on-click.html"
    },
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/"
    },
    {
      value: {},
      key: "animation",
      label: "Animation",
      tag: "choose-animation",
      type: "choose-animation",
      docPath: "properties/animation.html"
    },
    {
      value: "t-center",
      key: "textAlignement",
      label: "Text alignement",
      tag: "align-picker",
      type: "align-picker",
      options: ["t-left", "t-center", "t-right", "t-justify"],
      docPath: "properties/text-alignement.html"
    },
    {
      value: "btn-border",
      key: "buttonStyle",
      label: "Button Style",
      tag: "button-style-picker",
      type: "button-style-picker",
      options: ["btn-default", "btn-border", "btn-border-bottom"],
      docPath: "properties/button-style.html"
    },
    {
      value: 0,
      key: "borderRadius",
      label: "Border radius",
      tag: "cling-slider",
      type: "cling-slider",
      options: {
        min: 0,
        max: 50
      },
      docPath: "properties/border-radius.html"
    },
    {
      value: 0,
      key: "boxShadow",
      label: "Shadow",
      tag: "cling-slider",
      type: "cling-slider",
      options: {
        min: 0,
        max: 25
      },
      docPath: "properties/border-radius.html"
    },
    {
      value: 12,
      key: "fontBaseSize",
      label: "Font Base Size",
      tag: "input",
      type: "number",
      docPath: "properties/font-base-size.html"
    },
    {
      value: 400,
      key: "fontWeight",
      label: "Font Weight",
      tag: "input",
      type: "number",
      docPath: "properties/font-weight.html"
    },
    {
      value: "",
      key: "colorScheme",
      label: "Color Style",
      tag: "color-scheme-select",
      type: "color-scheme-select",
      docPath: "properties/color-style.html",
      options: [
        {
          id: "primary-btn",
          label: "Opaque 1"
        },
        {
          id: "secondary-btn",
          label: "Opaque 2"
        },
        {
          id: "tertiary-btn",
          label: "Opaque 3"
        },
        {
          id: "dark-btn",
          label: "Opaque dark"
        },
        {
          id: "light-btn",
          label: "Opaque light"
        },
        {
          id: "primary-transparent-btn",
          label: "Transparent 1"
        },
        {
          id: "secondary-transparent-btn",
          label: "Transparent 2"
        },
        {
          id: "tertiary-transparent-btn",
          label: "Transparent 3"
        },
        {
          id: "dark-transparent-btn",
          label: "Transparent dark"
        },
        {
          id: "light-transparent-btn",
          label: "Transparent light"
        },
        {
          id: "btn-custom-color",
          label: "Custom"
        },
        {
          id: "btn-custom-color-2",
          label: "Custom 2"
        }
      ]
    },
    {
      value: true,
      key: "initalShow",
      label: "initially visible and not on toggle",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    }
  ],
  filter: [
    {
      value: "",
      key: "filter",
      label: "Filter",
      tag: "option-select",
      type: "option-select",
      docPath: "properties/filter.html",
      options: [
        {
          id: "sepia",
          type: "filter",
          label: "Sepia",
          value: "sepia(1)"
        },
        {
          id: "grayscale",
          type: "filter",
          label: "Grayscale",
          value: "grayscale(0.1)"
        },
        {
          id: "darken",
          type: "filter",
          label: "Darken",
          value: "brightness(0.5)"
        },
        {
          id: "lighten",
          type: "filter",
          label: "Lighten",
          value: "brightness(2)"
        },
        {
          id: "speed-1.5",
          type: "playback",
          label: "Faster Playback: 1.5x",
          value: 1.5
        },
        {
          id: "speed-2",
          type: "playback",
          label: "Faster Playback: 2x",
          value: 2
        },
        {
          id: "speed-3",
          type: "playback",
          label: "Faster Playback: 3x",
          value: 3
        },
        {
          id: "speed-0.5",
          type: "playback",
          label: "Slower Playback: 0.5x",
          value: 0.5
        },
        {
          id: "speed-0.25",
          type: "playback",
          label: "Slower Playback: 0.25x",
          value: 0.25
        },
        {
          id: "mute",
          type: "volume",
          label: "Mute",
          value: 0
        }
      ]
    },
    {
      value: true,
      key: "initalShow",
      label: "initially visible and not on toggle",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    }
  ],
  link: [
    {
      value: "",
      key: "initalShow",
      label: "initially visible",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    },
    {
      value: multiLangTextObject(),
      key: "linkLabel",
      label: "Link Label",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/link-label.html"
    },
    {
      value: multiLangTextObject(),
      key: "URL",
      label: "URL",
      tag: "input",
      type: "text",
      multilang: true
    },
    {
      value: "",
      key: "icon",
      label: "Icon",
      tag: "icon-picker",
      type: "icon-picker",
      docPath: "properties/icon.html"
    }
  ],
  hotspot: [
    {
      value: {},
      key: "shape",
      label: "Shape",
      tag: "shape-picker",
      type: "shape-picker",
      docPath: "properties/shape.html"
    },
    {
      value: {},
      key: "behaviour",
      label: "On click",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/on-click.html"
    },
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/action-on-last-waypoint.html"
    },
    {
      value: {},
      key: "animation",
      label: "Animation",
      tag: "choose-animation",
      type: "choose-animation",
      docPath: "properties/animation.html"
    }
  ],
  includedFrame: [
    {
      value: "",
      key: "initalShow",
      label: "initially visible",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    },
    {
      value: multiLangTextObject(),
      key: "text",
      label: "Description",
      tag: "textarea",
      type: "textarea",
      multilang: true,
      docPath: "properties/description.html"
    },
    {
      value: multiLangTextObject(),
      key: "linkLabel",
      label: "Link Label",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/link-label.html"
    },
    {
      value: multiLangTextObject(),
      key: "URL",
      label: "URL",
      tag: "input",
      type: "text",
      multilang: true
    }
  ],
  cover: [
    {
      value: multiLangTextObject(),
      key: "URL",
      label: "URL",
      tag: "input",
      type: "text",
      multilang: true
    },
    {
      value: "",
      key: "top",
      label: "top",
      tag: "input",
      type: "percent"
    },
    {
      value: "",
      key: "left",
      label: "left",
      tag: "input",
      type: "percent"
    },
    {
      value: "",
      key: "bottom",
      label: "bottom",
      tag: "input",
      type: "percent"
    },
    {
      value: "",
      key: "right",
      label: "right",
      tag: "input",
      type: "percent"
    },
    {
      value: "",
      key: "width",
      label: "width",
      tag: "input",
      type: "percent"
    },
    {
      value: "",
      key: "height",
      label: "height",
      tag: "input",
      type: "percent"
    },
    {
      value: true,
      key: "initalShow",
      label: "initially visible and not on toggle",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    }
  ],
  branchTo: [
    {
      value: "",
      key: "initalShow",
      label: "initially visible",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    },
    {
      value: multiLangTextObject(),
      key: "text",
      label: "Description",
      tag: "textarea",
      type: "textarea",
      multilang: true,
      docPath: "properties/description.html"
    },
    {
      value: multiLangTextObject(),
      key: "linkLabel",
      label: "Link Label",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/link-label.html"
    },
    {
      value: multiLangTextObject(),
      key: "URL",
      label: "URL",
      tag: "input",
      type: "text",
      multilang: true
    }
  ],
  simpleTextForm: [
    {
      value: "",
      key: "initalShow",
      label: "initially visible",
      tag: "input",
      type: "checkbox"
    },
    {
      value: multiLangTextObject(),
      key: "title",
      label: "Title",
      tag: "input",
      type: "text",
      multilang: true,
      docPath: "properties/title.html"
    }
  ],
  logic: [
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/action-on-last-waypoint.html"
    }
  ],
  hotdot: [
    {
      value: "info",
      key: "icon",
      label: "Icon",
      tag: "icon-picker",
      type: "icon-picker",
      docPath: "properties/icon.html"
    },
    {
      value: "",
      key: "colorScheme",
      label: "Color Style",
      tag: "color-scheme-select",
      type: "color-scheme-select",
      docPath: "properties/color-style.html",
      options: [
        {
          id: "primary",
          label: "primary colors"
        },
        {
          id: "secondary",
          label: "secondary colors"
        },
        {
          id: "tertiary",
          label: "tertiary colors"
        },
        {
          id: "dark",
          label: "dark"
        },
        {
          id: "light",
          label: "light"
        },
        {
          id: "hotdot-custom-color",
          label: "custom"
        },
        {
          id: "hotdot-custom-color-2",
          label: "custom 2"
        }
      ]
    },
    {
      value: {},
      key: "behaviour",
      label: "On click",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/on-click.html"
    },
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/action-on-last-waypoint.html"
    },
    {
      value: {},
      key: "animation",
      label: "Animation",
      tag: "choose-animation",
      type: "choose-animation",
      docPath: "properties/animation.html"
    }
  ],
  textbox: [
    {
      value: {},
      key: "value",
      label: "Text Content",
      tag: "textbox-form",
      type: "textbox-form",
      multilang: true,
      docPath: "properties/textbox-content.html"
    },
    {
      value: "h-left",
      key: "alignement",
      label: "Horizontal alignement",
      tag: "align-picker",
      type: "align-picker",
      options: ["h-left", "h-center", "h-right"],
      docPath: "properties/horizontal-alignement.html"
    },
    {
      value: "v-top",
      key: "vAlignement",
      label: "Vertical alignement",
      tag: "align-picker",
      type: "align-picker",
      options: ["v-top", "v-center", "v-bottom"],
      docPath: "properties/vertical-alignement.html"
    },
    {
      value: "t-center",
      key: "textAlignement",
      label: "Text alignement",
      tag: "align-picker",
      type: "align-picker",
      options: ["t-left", "t-center", "t-right", "t-justify"],
      docPath: "properties/text-alignement.html"
    },
    {
      value: 0,
      key: "borderRadius",
      label: "Border radius",
      tag: "cling-slider",
      type: "cling-slider",
      options: {
        min: 0,
        max: 50
      },
      docPath: "properties/border-radius.html"
    },
    {
      value: 0,
      key: "boxShadow",
      label: "Shadow",
      tag: "cling-slider",
      type: "cling-slider",
      options: {
        min: 0,
        max: 25
      },
      docPath: "properties/border-radius.html"
    },
    {
      value: 12,
      key: "fontBaseSize",
      label: "Font Base Size",
      tag: "input",
      type: "number",
      docPath: "properties/font-base-size.html"
    },
    {
      value: 400,
      key: "fontWeight",
      label: "Font Weight",
      tag: "input",
      type: "number",
      docPath: "properties/font-weight.html"
    },
    {
      value: {},
      key: "scaleBehaviour",
      label: "TEXT SCALING BEHAVIOUR",
      tag: "choose-scale-behaviour",
      type: "choose-scale-behaviour",
      docPath: "properties/text-scaling-behaviour.html"
    },
    {
      value: {},
      key: "behaviour",
      label: "On click",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/on-click.html"
    },
    {
      value: {},
      key: "onLastFrame",
      label: "Action on last waypoint",
      tag: "choose-behaviour",
      type: "choose-behaviour",
      docPath: "properties/action-on-last-waypoint.html"
    },
    {
      value: {},
      key: "animation",
      label: "Animation",
      tag: "choose-animation",
      type: "choose-animation",
      docPath: "properties/animation.html"
    },
    {
      value: true,
      key: "initalShow",
      label: "initially visible and not on toggle",
      tag: "input",
      type: "checkbox",
      docPath: "properties/initially-visible-and-not-on-toggle.html"
    }
  ]
};
export function metaDataFormFields(key) {
  let def = defs[key];
  if (def) {
    // deep clone, so that mutations do not update defaults
    return JSON.parse(JSON.stringify(def));
  } else {
    return null;
  }
}

export function metaDataFromKeys() {
  return Object.keys(defs);
}

export function metaDataFormDefaults() {
  return defaults;
}

export function metaDataFormDefaultsFor(key) {
  return defaults.find(item => {
    return item.key === key;
  });
}
